(($) => {
	$(document).ready(() => {
		const $navList = $('.nav-main').attr('aria-expanded', 'false');
		const $navIcon = $('#nav-icon').attr('aria-expanded', 'false');
		const $searchBtn = $('#search-btn');

		function handleNavClick() {
			$('#nav-icon').toggleClass('open');
			const navOpen = $('#nav-icon').hasClass('open');

			if (navOpen) {
				$navList.fadeIn('fast').attr('aria-expanded', 'true');
				$searchBtn.hide();
				$navIcon.attr('aria-expanded', 'true');
				document.body.classList.add('noscroll');
			} else {
				$navList.fadeOut('fast').attr('aria-expanded', 'false');
				$searchBtn.fadeIn(' fast');
				$navIcon.attr('aria-expanded', 'false');
				document.body.classList.remove('noscroll');
			}
		}
		$navIcon.on('click', handleNavClick);
		$('.wp-block-table').each((i, el) => {
			$(el).wrap('<div class="table-wrapper"></div>');
		});
	});
})(jQuery);
